import { Component, Input, OnInit } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ScheduledPaymentModel } from '../../models/scheduled-payment.model';
import { PaymentMethodModel } from '../../customer.model';
import { ModalConfig } from 'app/shared/components/modal';

@Component({
  selector: 'app-scheduled-payment-details',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    CurrencyPipe,
    DatePipe,
    TitleCasePipe
  ],
  templateUrl: './scheduled-payment-details.component.html'
})
export class ScheduledPaymentDetailsComponent implements OnInit {
  payment!: ScheduledPaymentModel;
  data!: ModalConfig;
  cardInfo?: PaymentMethodModel;

  ngOnInit() {
    if (this.data && this.data.data) {
      this.payment = this.data.data.payment;
      
      // Get card information from modal data (passed from action handler)
      const paymentMethods: PaymentMethodModel[] = this.data.data.paymentMethods || [];
      
      if (this.payment.tokenId && paymentMethods.length > 0) {
        // Find the card that matches this payment's tokenId
        // Match against processorToken (primary) or transafeToken (fallback)
        this.cardInfo = paymentMethods.find(card => 
          card.processorToken === this.payment.tokenId || 
          card.transafeToken === this.payment.tokenId ||
          card.id === this.payment.tokenId
        );
      }
    }
  }
  
  getFormattedCardNumber(): string {
    if (!this.cardInfo?.account) return '****';
    // Get last 4 digits
    return this.cardInfo.account.slice(-4);
  }
  
  getFormattedExpiration(): string {
    if (!this.cardInfo?.expirationDate) return '';
    const exp = this.cardInfo.expirationDate;
    // Format MMYY to MM/YY
    if (exp.length === 4) {
      return `${exp.substring(0, 2)}/${exp.substring(2, 4)}`;
    }
    return exp;
  }

  getTotalWithCapitalCost(): number {
    if (!this.payment.capitalCostEnabled) {
      return this.payment.totalAmount || 0;
    }
    return (this.payment.totalAmount || 0) + (this.payment.capitalCostAmount || 0);
  }

  getCapitalCostPerPayment(): number {
    if (!this.payment.capitalCostEnabled) {
      return 0;
    }
    const principal = this.payment.calculatedWeeklyAmount || 0;
    const percentage = this.payment.capitalCostPercentage || 0;
    return Math.round(principal * percentage) / 100;
  }

  getChargePerPayment(): number {
    return (this.payment.calculatedWeeklyAmount || 0) + this.getCapitalCostPerPayment();
  }

  // Filter transaction history to only show actual payment attempts
  // Exclude "scheduled" type entries (they're just creation records)
  get actualPaymentHistory() {
    if (!this.payment.transactionHistory) return [];
    return this.payment.transactionHistory.filter(t => 
      t.status === 'success' || t.status === 'failed'
    );
  }
}
